import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dwmrepositorypopup',
  templateUrl: './dwmrepositorypopup.component.html',
  styleUrls: ['./dwmrepositorypopup.component.scss'],
})
export class DwmrepositorypopupComponent  implements OnInit {
  dwmData: any[] = [];

  displayedColumns: string[] = [
    
    'srNo',
    'category',
    'actionable',
    'timeFrom',
    'timeTo',
    'frequency',
    'calendor',
  
  ];
  
  constructor() { }



  ngOnInit() {
    this.loadDWMData();
    // this.displayedColumns = [
    //   'srNo', 'category', 'actionable',
    //   'timeFrom', 'timeTo', 'frequency','calendor',
    
    // ];
  }



  loadDWMData() {
    this.dwmData = [
      {
        category: "HR Review",
        actionable: "Prepare weekly HR dashboard",
        timeFrom: "09:00",
        timeTo: "10:00",
        frequency: "Weekly",
        calendor: "2025-01-15"
      },
      {
        category: "Team Meeting",
        actionable: "Conduct sprint planning meeting",
        timeFrom: "11:00",
        timeTo: "12:00",
        frequency: "Monthly",
        calendor: "2025-01-20"
      },
      {
        category: "Client Call",
        actionable: "Discuss requirements with client",
        timeFrom: "15:00",
        timeTo: "16:00",
        frequency: "Daily",
        calendor: "2025-01-25"
      }
    ];
  }
}
